export function formatNaira(value: number, opts?: { decimals?: boolean }) {
  const decimals = opts?.decimals ?? true;
  const safe = Number.isFinite(value) ? value : 0;
  return `₦${safe.toLocaleString('en-NG', {
    minimumFractionDigits: decimals ? 2 : 0,
    maximumFractionDigits: decimals ? 2 : 0,
  })}`;
}

export function maskNaira() {
  return '₦••••••';
}
